import React, { useState, useEffect } from 'react'
import { Toast } from '@cleartrip/bento'
import { checkUserLogin } from 'AccountsUtils'
import Warn from 'Lib/Status/icons/warning.svg'
import PrimaryTraveller from '../../components/Desktop/Expressway/PrimaryTraveller'
import SavedCard from '../../components/Desktop/Expressway/SavedCard'
import ExpresswayBanner from '../../components/Desktop/Expressway/ExpresswayBanner'
import './expressway.scss'

const Expressway = () => {
  const [showError, setShowError] = useState(false)
  const [showLoginMessage, setShowLoginMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (!checkUserLogin()) {
      setShowLoginMessage(true)
    }
  }, [])

  return (
    <>
      <If condition={showLoginMessage}>
        <div className="flex flex-center fs-25 w-100p mt-8">
          <Warn fill="#c30" width="36px" height="36px" />
          <div className="pt-2 ml-2">
            Please log in to access Expressway
          </div>
        </div>
        <Else />
        <div className="flex">
          <div className="ewCardsPrimaryTvlr flex-1">
            <div className="bg-cards apl-15 apr-15 apt-15 apb-15 w-630">
              <SavedCard setShowError={setShowError} setErrorMessage={setErrorMessage} />
            </div>
            <PrimaryTraveller />
            {
              showError &&
              <Toast message={errorMessage} onClose={() => setShowError(false)} className="row mt-15 ml-5 w-585 savedCardsErrorToast" closeBtn={true} error={true} />
            }
          </div>
          <div className="flex-1">
            <ExpresswayBanner />
          </div>
        </div>
      </If>
    </>

  )
}

export default Expressway
